<div class="editButton">
    <mat-icon class="example-icon text-green-500 cursor-pointer" aria-hidden="false" matTooltip="Edit" i18n-tooltip="Edit" svgIcon="mat_solid:edit"></mat-icon>
</div>